<template>
  <div>
    <EUIApp :loading="$auth.loading" />
    <GlobalError />
  </div>
</template>

<script>
import EUIApp from '@eui-page/app';
import GlobalError from './components/organism/global-error';

export default {
  name: 'MainApp',
  metaInfo: {
    titleTemplate: '%s Quotes | Novated'
  },
  components: {
    EUIApp,
    GlobalError
  }
};
</script>
